var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ShokurekishoJobHistoryCard,{attrs:{"basic-data":_vm.basicData,"current-card-id":_vm.currentCardId,"lead":_setup.skillsheetLead,"show-omonajiseki":false,"variant":"skillsheet"}})
}
var staticRenderFns = []

export { render, staticRenderFns }